import type { CalendarEventGiftRecipient, Contact, PublicUserProfile } from '@consumer/types/serializers'

export function isContact (object: any): object is Contact {
  return object && (
    'ownerId' in object
    && ('connectedUserId' in object
    || ('recipientType' in object && object.recipientType === 'Consumer::Contact'))
  )
}

export function isUser (object: any): object is PublicUserProfile {
  return object && 'recipientType' in object && object.recipientType === 'User'
}

export function isCalendarEventGiftRecipient (object: any): object is CalendarEventGiftRecipient {
  return object && ('contactId' in object || 'userId' in object) && 'recipientType' in object
}
